"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M16 13H3l6-9h1l2 2h1l3 7zm-2.5-3.5l-1-2.5h-1l-2-2-3 4.5L9 8l1 1 1-1 2.5 1.5zM5.94 7l-4.122 6H0l5-6h.94z"];
//# sourceMappingURL=mountain.js.map